import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=5c32dd65&scoped=true&"
import script from "./serviceDetails.vue?vue&type=script&lang=js&"
export * from "./serviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&id=5c32dd65&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32dd65",
  null
  
)

export default component.exports